module.exports = __webpack_public_path__ + "static/img/002.ee48f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/002.png
// module id = 7UqE
// module chunks = 0